// extracted by mini-css-extract-plugin
export var layoutContainer = "_4j-0";
export var layoutContainerNoRounding = "_4j-6";
export var layoutContainerOpen = "_4j-5";
export var layoutContainerResizing = "_4j-1";
export var mainContent = "_4j-2";
export var resizeDivider = "_4j-3";
export var slidePanel = "_4j-4";